import { Link } from "react-router-dom";

export default function RefundPage() {
  return (
    <div className="min-h-screen bg-cotton-100 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl font-bold text-primary mb-8">
          Return & Refund Policy
        </h1>
        
        <div className="bg-white p-8 rounded-lg shadow-soft space-y-6">
          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Return Policy</h2>
            <p className="text-muted-foreground leading-relaxed">
              At OGAS, we want you to be completely satisfied with your purchase. If you are not 
              satisfied, you may return the product within <strong>7 days</strong> of delivery.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Conditions for Return</h2>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Product must be unused and in original condition</li>
              <li>Product must have all original tags attached</li>
              <li>Product must be in original packaging</li>
              <li>Return request must be made within 7 days of delivery</li>
              <li>Proof of purchase (order ID/invoice) is required</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Non-Returnable Items</h2>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Products that have been worn, washed, or altered</li>
              <li>Products without original tags or packaging</li>
              <li>Products damaged due to misuse by the customer</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">How to Initiate a Return</h2>
            <ol className="list-decimal list-inside text-muted-foreground space-y-2">
              <li>Email us at admin@ogas.in with your Order ID and reason for return</li>
              <li>Our team will review and approve your return request within 24-48 hours</li>
              <li>Once approved, ship the product back to our address</li>
              <li>After inspection, refund will be initiated</li>
            </ol>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Refund Process</h2>
            <p className="text-muted-foreground leading-relaxed">
              Refunds will be processed within <strong>5-7 business days</strong> after we receive 
              and inspect the returned product. The refund will be credited to the original payment method.
            </p>
            <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
              <li>UPI/Wallet: 1-2 business days</li>
              <li>Credit/Debit Card: 5-7 business days</li>
              <li>Net Banking: 5-7 business days</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Exchange Policy</h2>
            <p className="text-muted-foreground leading-relaxed">
              We offer free exchange for size-related issues. Contact us within 7 days of delivery 
              for exchange requests.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Contact Us</h2>
            <p className="text-muted-foreground leading-relaxed">
              For return and refund queries:<br />
              <strong>Email:</strong> admin@ogas.in<br />
              <strong>Phone:</strong> +91 99947 93643<br />
              <strong>Return Address:</strong> OGAS, 25A, Padmavathipuram 1st Street, Gandhinagar Post, Tirupur - 641603, Tamil Nadu, India
            </p>
          </section>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-primary hover:underline">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
